export const initialAbility = [
  {
      "action": "read",
      "subject": "recruiter_report"
  },
  {
      "action": "download",
      "subject": "recruiter_report"
  },
  {
      "action": "read",
      "subject": "statuswise_report"
  },
  {
      "action": "download",
      "subject": "statuswise_report"
  },
  {
      "action": "read",
      "subject": "interview"
  },
  {
    "action": "read",
    "subject": "pofu"
  },
  {
      "action": "read",
      "subject": "my_candidates"
  },
  {
      "action": "read",
      "subject": "report"
  },
  {
      "action": "download",
      "subject": "report"
  },
  {
      "action": "read",
      "subject": "jobs"
  },
  {
      "action": "read",
      "subject": "auth"
  },
  {
      "action": "manage",
      "subject": "auth"
  },
  // ============================================
  // ATTENDANCE MODULE PERMISSIONS (Default for all users)
  // ============================================
  // All users can view their own attendance dashboard
  {
      "action": "read",
      "subject": "attendance_my_dashboard"
  },
  // All users can apply leave for themselves
  {
      "action": "apply",
      "subject": "leave"
  },
  // All users can apply regularization for themselves
  {
      "action": "apply",
      "subject": "regularization"
  },
  // ============================================
  // TASK MODULE PERMISSIONS (Default for all users)
  // ============================================
  // The `/apps/tasks` route/nav item is gated on its own dedicated
  // `task_management` subject (see `src/router/routes/apps.js` /
  // `src/navigation/vertical/apps-and-pages.js` — previously reused
  // `main_dashboard` as a stopgap). Abilities are backend-driven
  // (`userData.abilities`, set on login — see `src/libs/acl/ability.js`),
  // and this array is ONLY the pre-login/no-cached-session fallback, so
  // adding `task_management` here does not, by itself, grant it to an
  // already-logged-in user or guarantee a fresh login will either — see
  // the note below. It's included here anyway, same as
  // `attendance_my_dashboard` above, so a user with no cached
  // `userData` yet (or a corrupted/missing `abilities` field) still
  // defaults to having Task access, matching pre-change behavior, rather
  // than being silently locked out the moment this dedicated subject was
  // introduced.
  {
      "action": "read",
      "subject": "task_management"
  },
  // TODO(backend): once the backend formally adds `task_management` (read)
  // to each role's issued abilities, this default becomes redundant for
  // logged-in users and can be removed — `userData.abilities` returned by
  // login always REPLACES this fallback array wholesale (see
  // `getAbilities()` in `src/libs/acl/ability.js` and the `updateAbilities`
  // calls in `Login.vue`/`App.vue`), it is never merged with it. Until the
  // backend ships this, logging out and back in will NOT restore Task
  // access for a user whose role's backend-issued abilities omit
  // `task_management` — only clearing/lacking `userData` in localStorage
  // falls back to this array.
  // Offer letter configuration (admin UI — backend should issue per role)
  {
      "action": "read",
      "subject": "offer_configure"
  },
  {
      "action": "manage",
      "subject": "offer_configure"
  },
  // ============================================
  // ORGANIZATION CHART — NOT granted here by default.
  // Backend must issue on login for intended roles, e.g.:
  //   { "action": "read", "subject": "org_chart" }   // page + nav
  //   { "action": "manage", "subject": "org_chart" } // show inactive
  // Admins with { "action": "manage", "subject": "all" } already pass route/nav ACL.
  // See src/utils/org-chart-permissions.js and OrgChart.vue header comment.
  // ============================================
  // ============================================
  // Role-specific attendance permissions should be added by backend:
  // - attendance_team_dashboard (for managers, HR, admins)
  // - apply_on_behalf_leave (for managers, HR)
  // - apply_on_behalf_leave_all (for HR-Director, Admin, Master)
  // Reimbursement apply-on-behalf is a dedicated pair (do not reuse leave keys):
  // - apply_on_behalf + apply_on_behalf_reimbursement (managers, HR — reportees)
  // - apply_on_behalf + apply_on_behalf_reimbursement_all (HR-Director, Admin, Master)
  // Invoice Tracker tabs are dedicated read subjects (do not reuse `invoice` for all tabs):
  // - invoice_overview, invoice_candidate_revenue, invoice_collections,
  //   invoice_gstr1, invoice_gstr3b, invoice_finance_dashboard,
  //   invoice_recruiter_dashboard, invoice_contractual_billing
  // Seed: SattvaATS/migrations/seed_invoice_dashboard_permissions.sql then re-login.
  // - approve_leave_manager (for managers, HR)
  // - approve_leave_all (for HR-Director, Admin, Master)
  // - approve_regularization_manager (for managers, HR)
  // - approve_regularization_all (for HR-Director, Admin, Master)
  // - attendance_config (for Admin, Master)
  // ============================================
]

export const _ = undefined
